import {Link} from "react-router-dom";

type RightSectionBlockProps = {
  title: string;
  htmlBlurb?: () => JSX.Element;
  stringBlurb?: string;
  previousBtn: string;
  nextBtn: string;
  mainContent: JSX.Element;
  disablePreviousBtn?: boolean;
  disableNextBtn?: boolean;
  setShowModal?: React.Dispatch<React.SetStateAction<boolean>>;
};

const RightSectionBlock = ({
  title,
  htmlBlurb,
  stringBlurb,
  previousBtn,
  nextBtn,
  mainContent,
  disablePreviousBtn,
  disableNextBtn,
}: RightSectionBlockProps) => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="right-section-blk">
      <div className="right-content-blk">
        <h2>{title}</h2>
        <p>{stringBlurb ? stringBlurb : htmlBlurb ? htmlBlurb() : null}</p>
        {mainContent}
      </div>
      <div className="footer-button-blk">
        {disablePreviousBtn ? (
          <a
            href="/"
            onClick={(e) => e.preventDefault()}
            className="disabled-link">
            Previous
          </a>
        ) : (
          <Link
            to={previousBtn}
            className="previous-link"
            onClick={scrollToTop}>
            Previous
          </Link>
        )}
        {disableNextBtn ? (
          <a
            href="/"
            onClick={(e) => e.preventDefault()}
            className="disabled-link">
            Next
          </a>
        ) : (
          <Link to={nextBtn} onClick={scrollToTop}>
            Next
          </Link>
        )}
      </div>
    </div>
  );
};

export default RightSectionBlock;
